export const load = () => ({
	title: 'Sleep Panels',
	showTitle: true,
});
